import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import { logout, removeGreetings } from "../actions/authActions";
import { changePage } from "../actions/changePageAction";
import { clearErrors } from "../actions/errorActions";
import { getProjects } from "../actions/projectActions";
import { displayCreateFree } from "../actions/freeActions";
import { changeLanguage, updateUser } from "../actions/userActions";
import { FaHandPointRight } from "react-icons/fa";
import {
  deleteProfilePictures,
  pictureDownload,
} from "./../actions/pictureAction";
import i18n from "./helper/i18n";
import { Translation } from "./helper/transComp";
import {
  Button,
  Container,
  Form,
  Modal,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import NavigationLink from "./container/NavigationLink";
import ProfileLink from "./container/ProfileLink";
import { WebsocketContext } from "./../WebsocketContext";
import { FolderBlack } from "./../components/helper/icon/icon";
import OutsideAlerter from "./helper/functions/OutsideAlerter";
import ReCAPTCHA from "react-google-recaptcha";
import { withTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

function HeaderLoggedIn(props) {
  const wsContext = useContext(WebsocketContext);

  // --- Local state (mirrors original this.state) ---
  const [isOpen, setIsOpen] = useState(false);
  const [width, setWidth] = useState(0);
  const [displMenu, setDisplMenu] = useState(false);
  const [languages] = useState(["en", "de", "fr"]);
  const [currLan, setCurrLan] = useState("en");
  const [register, setRegister] = useState(false);
  const [login, setLogin] = useState(false);
  const [images, setImages] = useState([]);
  const [isAuthenticatedLocal, setIsAuthenticatedLocal] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [displayHelp, setDisplayHelp] = useState(false);
  const [projObj, setProjObj] = useState({});
  const [homeObj, setHomeObj] = useState({});
  const [addProjObj, setAddProjObj] = useState({});
  const [addItemObj, setAddItemObj] = useState({});
  const [addTaskObj, setAddTaskObj] = useState({});
  const [addChartObj, setAddChartObj] = useState({});
  const [currHelp, setCurrHelp] = useState(-1);
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [videoSrc, setVideoSrc] = useState("create_project_ws_EN.mp4");
  const [displayChat, setDisplayChat] = useState(false);
  const [profilePopupOpen, setProfilePopupOpen] = useState(false);
  const [showNewsLetter, setShowNewsLetter] = useState(4);
  const [displayFree, setDisplayFree] = useState(false);
  const [worksheetName, setWorksheetName] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const [accessType, setAccessType] = useState("free");

  const intervalRef = useRef(null);
  const prevIsAuthenticatedRef = useRef(props.isAuthenticated);

  // --- Helpers ---
  const updateWindowDimensions = useCallback(() => {
    setWidth(window.innerWidth);
  }, []);

  const checkLogIn = useCallback(() => {
    const { auth } = props;
    if (!auth || !auth.loginTimestamp) return;
    if (Date.now() > auth.loginTimestamp + 34200000) {
      setDisplayModal(true);
    }
    if (Date.now() > auth.loginTimestamp + 37800000) {
      props.logout();
    }
  }, [props]);

  const getLangTxt = useCallback(() => {
    switch (currLan) {
      case "de":
        return "DE";
      case "fr":
        return "FR";
      default:
        return "EN";
    }
  }, [currLan]);

  const [searchParams] = useSearchParams();
  // --- componentDidMount ---
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);

    setCurrLan(i18n.language);
    checkLogIn();

    intervalRef.current = setInterval(() => checkLogIn(), 300000); // every 5 min

    if (props.auth && props.auth.greetings) {
      setTimeout(() => {
        props.removeGreetings();
      }, 5 * 60 * 1000);
    }

    // wsContext?.connect && wsContext.connect();
    const token = searchParams.get("token");
    if (token) {
      setAccessType("freeWithToken");
    }

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [
    checkLogIn,
    props.auth,
    props.removeGreetings,
    updateWindowDimensions /* wsContext */,
  ]);

  // --- componentDidUpdate equivalents ---

  // Sync local isAuthenticated + picture download logic on auth change
  useEffect(() => {
    if (isAuthenticatedLocal !== props.isAuthenticated) {
      setIsAuthenticatedLocal(props.isAuthenticated);
      if (props.picture?.images) {
        if (!props.picture.images.length) {
          if (!props.picture.images.user) props.pictureDownload();
        }
      }
    }
  }, [
    props.isAuthenticated,
    isAuthenticatedLocal,
    props.picture,
    props.pictureDownload,
  ]);

  // When login/register flags are true and user becomes authenticated
  useEffect(() => {
    const prev = prevIsAuthenticatedRef.current;
    const curr = props.isAuthenticated;

    if ((login || register) && curr) {
      setLogin(false);
      setRegister(false);
      setIsOpen(false);
      props.changePage("home");
      props.clearErrors();
    }

    prevIsAuthenticatedRef.current = curr;
  }, [props.isAuthenticated, login, register, props]);

  // Sync images from props.picture
  useEffect(() => {
    if (props.picture?.images && props.picture.images !== images) {
      setImages(props.picture.images);
    }
  }, [props.picture, images]);

  // --- handlers ---
  const toggle = () => setIsOpen((v) => !v);

  const displayPage = (e, pageTitle) => {
    e.preventDefault();
    props.changePage(pageTitle);
  };

  const handleSubmit = (e) => {};

  // --- Render ---
  const userImg = (
    <img
      className="profilePic"
      src={`/img/user.png`}
      alt={"profil"}
      style={{ width: "40px", height: "40px" }}
    />
  );

  return (
    <Fragment>
      <div>
        <Navbar
          bg="light"
          expand="md"
          fixed="top"
          key={"md"}
          className="mb-3"
          expanded={navbarExpanded}
          onToggle={() => {
            setNavbarExpanded((v) => !v);
          }}
        >
          <Container>
            <img
              src={`/img/logo.webp`}
              alt={"logo"}
              style={{ height: "60px" }}
            />
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              style={{ background: "#a1c5a3", marginRight: "10px" }}
            />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-0 ms-auto">
                <div
                  className="nav-link"
                  style={{
                    margin: "9px auto",
                    cursor: "pointer",
                    fontWeight: "700",
                  }}
                  onClick={() => {
                    props.displayCreateFree(true);
                  }}
                >
                  <span id="backgrounded">
                    <Translation
                      str={
                        accessType === "free"
                          ? "HeaderFreeLink"
                          : "HeaderFreeLink1"
                      }
                    />
                  </span>
                </div>

                <div style={{ margin: "9px auto", fontWeight: "700" }}>
                  <NavigationLink
                    navLinkClicked={() => {
                      setIsOpen(false);
                    }}
                    target={true}
                    id="headerForBackground"
                    filter={`./${currLan}/register`}
                  >
                    <span id="backgrounded">
                      <Translation str={"HeaderFreePremium"} />
                    </span>
                  </NavigationLink>
                </div>

                <NavDropdown
                  title={
                    props.user.language !== currLan ? (
                      <span
                        style={{
                          color: "#424141",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <img
                          src={"/img/world.svg"}
                          alt="language"
                          style={{ width: "20px", marginRight: "2.5px" }}
                        />{" "}
                        {getLangTxt()}
                      </span>
                    ) : (
                      <span
                        style={{
                          color: "#424141",
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        <img
                          src={"/img/world.svg"}
                          alt="language"
                          style={{ width: "20px" }}
                        />{" "}
                        {getLangTxt()}
                      </span>
                    )
                  }
                  id="basic-nav-dropdown-topnav"
                >
                  {_.map(languages, (tval, tind) => {
                    return (
                      <NavDropdown.Item
                        className={"hoverMenu buttonContainerStart"}
                        style={{
                          backgroundColor: currLan === tval ? "#d6d6d6" : "",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setCurrLan(tval);
                          setIsOpen(false);
                          setNavbarExpanded(false);
                          i18n.changeLanguage(tval);
                          props.updateUser({
                            modUser: true,
                            offer: "free",
                            language: tval,
                          });
                        }}
                        key={tind}
                      >
                        <span
                          style={{ marginLeft: "0.25rem", cursor: "pointer" }}
                        >
                          {tval === "en" ? (
                            <>
                              <img
                                src={`/img/english.webp`}
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                                alt="English"
                              />
                              <span>English </span>
                            </>
                          ) : tval === "de" ? (
                            <>
                              <img
                                src={`/img/german.webp`}
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                                alt="Deutsch"
                              />
                              <span>Deutsch</span>
                            </>
                          ) : (
                            <>
                              <img
                                src={`/img/french.webp`}
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                                alt="Français"
                              />
                              <span>Français</span>
                            </>
                          )}
                        </span>
                      </NavDropdown.Item>
                    );
                  })}
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </Fragment>
  );
}

HeaderLoggedIn.propTypes = {
  auth: PropTypes.object.isRequired,
  changePage: PropTypes.func.isRequired,
  page: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  getProjects: PropTypes.func.isRequired,
  picture: PropTypes.object,
  logout: PropTypes.func.isRequired,
  deleteProfilePictures: PropTypes.func.isRequired,
  pictureDownload: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  displayCreateFree: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  page: state.page,
  isAuthenticated: state.auth.isAuthenticated,
  picture: state.picture,
  user: state.user,
  ws: state.ws,
  company: state.company,
});

export default connect(mapStateToProps, {
  changePage,
  clearErrors,
  getProjects,
  logout,
  deleteProfilePictures,
  pictureDownload,
  updateUser,
  changeLanguage,
  removeGreetings,
  displayCreateFree,
})(HeaderLoggedIn);
